import * as React from 'react';
import { Box, Rating, Typography } from '@mui/material';

import { useAppSelector } from 'store/store.hook';
import { selectVisualizationSliceInfo } from 'store/slices/visualization.slice';

interface VisualizationZoneInfoContentProps {
  floorId: number;
  zoneId: number;
}

export const VisualizationZoneInfoContent: React.FC<VisualizationZoneInfoContentProps> = (props) => {
  const { floors } = useAppSelector(selectVisualizationSliceInfo);
  const { floorId, zoneId } = props;

  const zone = floors?.get(floorId)?.zones.get(zoneId) || null;

  if (!zone) {
    return (
      <Box
        sx={{
          paddingX: 1,
          paddingY: 0.5,
        }}
      >
        <Typography color="textSecondary" variant="caption">
          No zone info
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        cursor: 'pointer',
        paddingX: 1,
        paddingY: 0.5,
      }}
    >
      <Typography variant="subtitle2">{zone.name}</Typography>

      <Box
        sx={{
          marginTop: 1,
        }}
      >
        <Typography color="textSecondary" variant="caption">
          Last service time:
        </Typography>
        <Typography
          color="primary"
          sx={{
            fontWeight: 600,
            letterSpacing: 1.5,
          }}
        >
          {zone.lastService}
        </Typography>
      </Box>

      <Rating
        value={zone.rating}
        readOnly
        size="small"
        sx={{
          marginTop: 1,
        }}
      />
    </Box>
  );
};
